import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { ExternalUrlsAdminListWire } from './types';
import { ExternalUrlsSearchModel } from './types-store';

export const api = {

  loadList: async (
    model: ExternalUrlsSearchModel, startIndex: number, maxResults: number
  ): Promise<ExternalUrlsAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchExternalUrls)
      .resource<Response>()
      .filter({
        displayNotSelected: true,
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteExternalUrl: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteExternalUrlItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
